import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const Intro = () => (
  <section data-testid="intro-section" className="bg-ink py-24 md:py-32">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 lg:grid-cols-12 lg:px-10">
      <Reveal className="lg:col-span-4">
        <span className="eyebrow">Legacy Custom Homes</span>
        <span className="gold-rule mt-5" aria-hidden="true" />
      </Reveal>
      <div className="lg:col-span-8">
        <Reveal delay={0.1}>
          <p className="font-serif text-3xl font-medium leading-snug text-white md:text-4xl" data-testid="intro-headline">
            From complete home renovations to ground-up new construction, Legacy Custom Homes
            transforms ideas into <span className="text-gold">beautifully built spaces</span>.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-gray-400 md:text-lg">
            Whether you're reimagining an existing home, adding new living space, or building your
            dream home from the ground up, we manage each project with attention to craftsmanship,
            detail, and the finished result.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <a
            href="#story"
            data-testid="intro-story-link"
            className="group mt-10 inline-flex items-center gap-3 font-accent text-xs font-semibold uppercase tracking-[0.25em] text-gold transition-colors duration-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-gold"
          >
            Our Story
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" aria-hidden="true" />
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
